import { blocosDaDemonstracaoDaNotificacao } from '../demo/fixtureDaNotificacao';
import {
  type BlocoDo,
  type ConfigDoProduto,
  ESQUEMAS_DOS_PRODUTOS,
  IDS_DOS_PRODUTOS,
  type TemplateDoRelatorio,
} from '../types';

/** Títulos e blocos dos focos são os do `catalogoDeNotificacao` do core. */
const templates: TemplateDoRelatorio[] = [
  {
    id: 'closing',
    title: 'Fechamento do período',
    description: 'Envios, entregas e manifestações numa visão completa.',
    prompt:
      'Quero ver as notificações do período, o que foi entregue e o que ainda não teve resposta.',
    blocks: [
      'overview',
      'channels',
      'delivery',
      'manifestations',
      'batches',
      'evidence',
      'actions',
    ],
  },
  {
    id: 'delivery',
    title: 'O que chegou e o que foi lido',
    description: 'Entrega e leitura por canal e no consolidado.',
    prompt: 'Quero entender o que foi entregue e lido em cada canal.',
    blocks: ['overview', 'channels', 'delivery', 'evidence', 'actions'],
  },
  {
    id: 'manifestations',
    title: 'Como os notificados responderam',
    description: 'Discordâncias, pedidos de negociação e manifestações.',
    prompt: 'Quero entender como os notificados responderam.',
    blocks: ['overview', 'manifestations', 'batches', 'actions'],
  },
];

export const configDaNotificacao: ConfigDoProduto = {
  produto: 'notificacao',
  rota: '/notificacoes/relatorios',
  endpoint: '/relatorios/notificacao',
  prefixoDoArquivo: 'arbitralis-notificacao',
  blocos: IDS_DOS_PRODUTOS.notificacao.blocks,
  esquemas: ESQUEMAS_DOS_PRODUTOS.notificacao,
  blockLabels: {
    overview: 'Visão geral',
    channels: 'Desempenho por canal',
    delivery: 'Entrega e leitura',
    manifestations: 'Manifestações',
    batches: 'Comparação por lote',
    evidence: 'Evidências e certificados',
    actions: 'Próximos passos',
  } satisfies Record<BlocoDo<'notificacao'>, string>,
  templates,
  blocosDaDemonstracao: blocosDaDemonstracaoDaNotificacao,
  defaultPreferences: { remember: true, focus: 'closing', blocks: templates[0].blocks },
  stages: [
    'Organizando seu pedido',
    'Consultando notificações',
    'Conferindo os indicadores',
    'Construindo os blocos',
    'Finalizando seu relatório',
  ],
  focoInicial: 'closing',
  blocoDoPrimeiroInsight: 'delivery',
  palavrasDoModelo: [
    { padrao: /entreg|leitura|lid[ao]s?\b|abert|canal|whatsapp|e-?mail|sms|rcs/, foco: 'delivery' },
    { padrao: /manifest|respo|discord|comprovante/, foco: 'manifestations' },
    { padrao: /relatorio|dashboard|fechamento|resultado|notificac|lote/, foco: 'closing' },
  ],
  textos: {
    origem: { rotulo: 'Notificações', href: '/notificacoes' },
    tituloPadrao: 'Fechamento de notificações',
    categoria: 'NOTIFICAÇÃO',
    semDados:
      'Não encontramos notificações disparadas neste recorte. Experimente ampliar o período.',
    comecar: 'Começar com um fechamento',
    cabecalhoDoDocumento: 'Notificação · relatório personalizado',
    carteira: 'Suas notificações extrajudiciais',
    cabecalhoDoPdf: 'NOTIFICAÇÃO · RELATÓRIO',
    resumoDaDemonstracao: (pedido) =>
      `Você quer um relatório de notificação com este foco: “${pedido}”. Vou organizar os indicadores nos blocos abaixo e considerar os detalhes que você trouxe. É isso que você precisa?`,
    foraDoEscopoDaDemonstracao:
      'Eu cuido de relatórios e dashboards de notificação extrajudicial. Posso analisar envios, entregas, leituras e manifestações, comparar lotes e explicar indicadores. O que você gostaria de entender sobre suas notificações?',
  },
};
